import { render, staticRenderFns } from "./channelPopupRussia.vue?vue&type=template&id=bfbe514a&scoped=true"
import script from "./channelPopupRussia.vue?vue&type=script&lang=js"
export * from "./channelPopupRussia.vue?vue&type=script&lang=js"
import style0 from "./channelPopupRussia.vue?vue&type=style&index=0&id=bfbe514a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbe514a",
  null
  
)

export default component.exports